import React from 'react'
import { useState } from 'react';
import './FilterSearchEvent.css'
import MultiRangeSlider from "multi-range-slider-react";
// import './popup.css';

const FilterSearchEvent = (props) => {
  // const [value, setValue] = useState(0);
  const [value1, setValue1] = useState(0);
  // const [value2, setValue2] = useState(0);
  const [minExpValue, setminExpValue] = useState(0);
  const [maxExpValue, setmaxExpValue] = useState(0);
  const [minSalValue, setminSalValue] = useState(0);
  const [maxSalValue, setmaxSalValue] = useState(0);
  const [partTime, setPartTime] = useState(false);
  const [fullTime, setFullTime] = useState(false);
  const [contract, setContract] = useState(false);
 const [ available,setAvailable] = useState('');
  const handleInput = (e) => {
    setminExpValue(e?.minValue);
    setmaxExpValue(e?.maxValue);
  };

  const handleChange = (e) => {
    setminSalValue(e.minValue);
    setmaxSalValue(e.maxValue);
  }




  const searchFilterBackupData = props?.searchFilterBackupData
  const setSearchFilterData = props?.setSearchFilterData
  const showFilter = props?.showFilter
  const setShowFilter = props?.setShowFilter

  const handleChange1 = (event) => {
    setValue1(event.target.value);
  }

  console.log('experience',  minExpValue , maxExpValue )
  console.log('distance', value1)
  console.log('salary', minSalValue , maxSalValue)
  console.log('searchFilterBackupData', searchFilterBackupData)





  const handleSearchFilter = ({minExpValue, minSalValue}, {maxExpValue, maxSalValue} ,{value1},{available}) => {
    let temp = [...searchFilterBackupData];
  
    let filteredData = temp;
  
    if ( minExpValue || maxExpValue  ||   minExpValue && maxExpValue ) {
      filteredData = filteredData?.filter((item) =>
        parseInt(item?.experience_det[0]?.experience) >= parseInt(minExpValue)  &&
        parseInt(item?.experience_det[0]?.experience) <= parseInt(maxExpValue)
      );

      console.log(filteredData, "1222")
    }
  
    if (value1) {
      filteredData = filteredData?.filter((item) =>
        parseInt(item?.distance) <= value1
      );
      
      console.log(filteredData, "dis")
    }
  
    if ( minSalValue || maxSalValue ||  minSalValue && maxSalValue) {
      filteredData = filteredData?.filter((item) =>
        parseInt(item?.expected_salary) >= minSalValue &&
        parseInt(item?.expected_salary) <= maxSalValue
      );
      
      console.log(filteredData, "salll")
    }
  
    if (available) {
      filteredData = filteredData?.filter((item) =>
        item?.employment_type === available
      );
      
      console.log(filteredData, "available")
    }
  
    setSearchFilterData(filteredData);
    setShowFilter(!showFilter);
  };
  

  return (
    <div className="popup">
      <div className="popup-inner">
        <span>Type of employment contract</span>
        <div className=' className="hashtags-keys mb-2'>


          <button className={partTime ? "active-tag " : "deactive-tags"}
            onClick={() => {
              setPartTime(!partTime)
              setAvailable("Part Time")
              setContract(false)
              setFullTime(false)

            }}

          >Part Time  </button>



          <button className={fullTime ? "active-tag " : "deactive-tags"}
            onClick={() => {
      setFullTime(!fullTime)
      setPartTime(false)
      setContract(false)
      setAvailable("Full Time")
            }}
          > Full Time </button>


          <button
            className={contract ? "active-tag " : "deactive-tags"}
            onClick={() => {
          setContract(!contract)
          setPartTime(false)
          setFullTime(false)
          setAvailable("Contract")
            }}> Contract </button>
        </div>


        <div className="slider-container" >
          <div className='upper-elements'>
            <label htmlFor="experience">Experience:</label>
            <span className="value">{minExpValue}-{maxExpValue} yrs</span>

          </div>

          <MultiRangeSlider

            min={0}
            max={30}
            step={1}
            minValue={minExpValue}
            maxValue={maxExpValue}
            onInput={(e) => {
              handleInput(e);
            }}
            label={false}
            ruler={false}
            style={{
              border: "none",
              boxShadow: "none", padding: "15px 10px"
            }}
            barLeftColor=""
            barInnerColor="#007aff"
            barRightColor=""
            thumbLeftColor="#007aff"
            thumbRightColor="#007aff"


          />



        </div>

        <div className="slider-container" style={{height:"15vh"}}>
          <div className='upper-elements'>
            <label htmlFor="distance">Maximum Distance:</label>
            <span className="value">{value1}</span>
          </div>
          <div>
            <input
              id="distance"
              type="range"
              min="0"
              max="1000"
              step="0"
              value={value1}
              onChange={handleChange1}
       
            />
          </div>

        </div>


        <div className="slider-container" >
          <div className='upper-elements'>
            <label htmlFor="salary">Salary:</label>
            <span className="value">{minSalValue}-{maxSalValue}</span>
          </div>



          <MultiRangeSlider

            min={0}
            max={10000}
            step={0}
            minValue={minSalValue}
            maxValue={maxSalValue}
            onInput={(e) => {
              handleChange(e);
            }}
            label={false}
            ruler={false}
            style={{
              border: "none",
              boxShadow: "none", padding: "15px 10px"
            }}
            barLeftColor=""
            barInnerColor="#007aff"
            barRightColor=""
            thumbLeftColor="#007aff"
            thumbRightColor="#007aff"


          />






        </div>











        <button className="search-button" onClick={(e) => {
          e.stopPropagation()
 handleSearchFilter({minExpValue, minSalValue}, {maxExpValue, maxSalValue} ,{value1},{available})
        }}>Search Now</button>
      </div>
    </div >
  )
}

export default FilterSearchEvent

  // const handleSearchFilter = ({minExpValue, minSalValue}, {maxExpValue, maxSalValue} ,{value1} ,{available}) => {

  //     let temp = [...searchFilterBackupData];

  //     const newExpData = temp?.filter((item) => (parseInt(item?.experience_det[0]?.experience)  >= minExpValue && parseInt(item?.experience_det[0]?.experience )<= maxExpValue))
  //     const newDisData = temp?.filter((item) => (parseInt(item?.distance)) <= value1)
  //     const newSalData = temp?.filter((item) => (parseInt(item?.expected_salary) >= minSalValue && parseInt(item?.expected_salary) <= maxSalValue    ))
  //     const newAvaData = temp?.filter((item)=>(
  //       item?.employment_type == available))
    
  //     console.log(' newExpData', newExpData)
  //     console.log('newDisData', newDisData)
  //     console.log('newSalData', newSalData)
  //     console.log('newAvaData', newAvaData)
  //     console.log('newAvaData', temp?.employment_type)

  //     const combinedData = [...newExpData, ...newDisData, ...newSalData , ...newAvaData ]
  //     const filteredData = Array.from(new Set(combinedData));
  //     setSearchFilterData(filteredData)
  //     setShowFilter(!showFilter)

  //     console.log('avaliable', available)
    
  // }